<template>
  <div>
    <span v-if="data === null">加载中...</span>
    <form-with-type v-if="data !== null"
                    :type="data.type"
                    :key="data.type + data.id"
                    v-model="data"
                    @submit="onSubmit"></form-with-type>
  </div>
</template>

<script>
import request from '../../api/request'
import FormWithType from './FormWithType'
import { isObject, isArray } from 'lodash';

export default {
  name: 'ProductManagementEditProduct',
  components: {
    FormWithType
  },
  data() {
    return {
      type: '',
      productId: 0,
      data: null
    }
  },
  created() {
    this.type = this.$router.currentRoute.params['type'] || ''
    this.productId = parseInt(this.$router.currentRoute.params['id']) || 0
    this.reload()
  },
  methods: {
    onSubmit() {
      request.product.post('product_add_or_modify',
        {
          id: this.data.id,
          type: this.data.type,
          data: this.data.data,
          attachments: this.data.attachments,
          channel: this.data.channel || {}
        }
      ).then(() => {
        this.$message.success("修改成功")
        this.reload()
      })
    },
    reload() {
      if (['published', 'pending'].includes(this.type) && this.productId > 0) {
        let api = (this.type == 'pending') ? 'product_pending_get_detail' : 'product_get_detail'
        request.product.post(api, { id: this.productId }).then(r => {
          this.data = r.data
          if (!isObject(this.data.data) || isArray(this.data.data)) {
            this.data.data = {}
          }
        })
      }
    }
  }
}
</script>
